<script lang="ts" setup>
import { ref } from 'vue';

defineProps({
  showBackAction: { type: Boolean, default: true } /** Whether to show action to navigate back */,
  wideMainContent: { type: Boolean, default: false },
});
const emit = defineEmits<{
  (e: 'go-back'): void;
}>();

const headerMobileEl = ref<HTMLElement>();

const onBackClick = () => {
  const event = new CustomEvent('back-button-triggered', {
    detail: {
      goBack: true,
    },
  });

  headerMobileEl.value?.dispatchEvent(event);

  emit('go-back');
};
</script>

<template>
  <div
    ref="headerMobileEl"
    :class="['header-mobile', { 'header-mobile--wide': wideMainContent }]"
  >
    <x-button
      v-if="showBackAction"
      class="header-mobile__back"
      variant="clear"
      @click="onBackClick"
    >
      <ot-icon
        class="header-mobile__back-icon"
        name="arrow-left"
      />
    </x-button>
    <div class="header-mobile__content-wrapper">
      <div
        v-if="$slots['top-content']"
        class="header-mobile__top-content"
      >
        <slot name="top-content" />
      </div>
      <div
        v-if="$slots['main-content']"
        class="header-mobile__main-content"
      >
        <slot name="main-content" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.header-mobile {
  --main-content-padding: 0 24px;
  --main-with-top-padding: var(--custom-main-with-top-padding, var(--main-content-padding));

  $content-side-padding: 16px;
  $back-btn-space-left: 4px;

  position: sticky;
  z-index: var(--page-sticky-header-z-index);
  top: 0;
  display: flex;
  flex-direction: column;
  background-color: var(--header-mobile-custom-bg, rgb(var(--v-theme-elevation-0)));

  &__back-icon {
    width: 18px;
    height: 18px;
  }

  &__back {
    position: absolute;
    top: 30px;
    left: calc($content-side-padding + $back-btn-space-left);
    padding: 0;
    color: rgb(var(--v-theme-text-secondary));

    &::after {
      position: absolute;
      width: 50px;
      height: 50px;
      content: '';
    }
  }

  &__content-wrapper {
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: 20px $content-side-padding 8px;
    gap: 12px;
  }

  &__main-content {
    flex: 1 0 auto;
    padding: var(--main-content-padding);
  }

  &__top-content {
    flex: 1 0 auto;
    padding: 0 12px;
    margin-left: 22px;

    ~ .header-mobile__main-content {
      padding: var(--main-with-top-padding);
    }
  }
}

.header-mobile--wide {
  --custom-main-with-top-padding: 0;
}
</style>
